import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import "./ChangePassword.css";
import { useNavigate } from "react-router-dom";
import { MdOutlineCancel } from "react-icons/md";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { PostRequest } from "../../Utils/hooks/ApiHandler";
import { toast } from "sonner";
import useLocalStorageState from "use-local-storage-state";

// Zod schema for validation
const schema = z
  .object({
    oldPassword: z.string().min(1, "Old password is required"),
    newPassword: z
      .string()
      .min(6, "New password must be at least 6 characters"),
    confirmPassword: z.string().min(1, "Please confirm your password"),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });

export  function ChangePassword() {
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setshowConfirmPassword] = useState(false);
  const [showOldPassword, setshowOldPassword] = useState(false);
  const [customer, setCustomer] = useLocalStorageState("customer");
  const navigate = useNavigate();

  const user_id = customer?.customer_details?.id;
  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;
  const headers = {
    authentication: rf,
    Authorization: token,
  };

  const extras = { customer, setCustomer, rf, navigate };
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: zodResolver(schema),
  });

  const handleFormSubmit = async (data) => {
    try {
      const payload = {
        old_password: data.oldPassword,
        password: data.newPassword,
        conf_password: data.confirmPassword,
        user_id: user_id,
      };

      const res = await PostRequest(
        "/auth/ChangePassword",
        payload,
        false,
        { headers },
        extras
      );
      if (res?.status === "success") {
        toast.success(res.message);
        reset(); // Clear form
        navigate(-1); // Go back
      } else {
        console.error(
          "Change failed:",
          res?.msg || res?.message || "Unknown error"
        );

        toast.error(res.message);
      }
    } catch (err) {
      console.error("API Error:", err);

      alert("An unexpected error occurred. Please try again.");
    }
  };

  const onClose = () => {
    navigate(-1);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <div className="d-flex justify-content-between">
          <h4>Create New Password</h4>
          <MdOutlineCancel
            style={{
              width: "30px",
              height: "30px",
              color: "lightgray",
              cursor: "pointer",
            }}
            onClick={onClose}
          />
        </div>

        <form onSubmit={handleSubmit(handleFormSubmit)} className="form">
          {/* Hidden username field to satisfy browser and password managers */}
          <input
            type="text"
            name="username"
            autoComplete="username"
            value={customer?.customer_details?.email || ""}
            readOnly
            hidden
          />
          <div className="form-group">
            <label className="form-label">Old Password</label>
            <div className="input-wrapper">
              <input
                className="form-control"
                type={showOldPassword ? "text" : "password"}
                autoComplete="current-password"
                {...register("oldPassword")}
              />

              <span
                className="eye-icon"
                onClick={() => setshowOldPassword((prev) => !prev)}
              >
                {showOldPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            {errors.oldPassword && (
              <p className="error">{errors.oldPassword.message}</p>
            )}
          </div>

          <div className="form-group">
            <label className="form-label">New Password</label>
            <div className="input-wrapper">
              <input
                className="form-control"
                type={showNewPassword ? "text" : "password"}
                autoComplete="new-password"
                {...register("newPassword")}
              />

              <span
                className="eye-icon"
                onClick={() => setShowNewPassword((prev) => !prev)}
              >
                {showNewPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            {errors.newPassword && (
              <p className="error">{errors.newPassword.message}</p>
            )}
          </div>

          <div className="form-group">
            <label className="form-label">Confirm Password</label>
            <div className="input-wrapper">
              <input
                className="form-control"
                type={showConfirmPassword ? "text" : "password"}
                autoComplete="new-password"
                {...register("confirmPassword")}
              />

              <span
                className="eye-icon"
                onClick={() => setshowConfirmPassword((prev) => !prev)}
              >
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            {errors.confirmPassword && (
              <p className="error">{errors.confirmPassword.message}</p>
            )}
          </div>

          <div className="actions">
            <button type="submit" className="btn btn-default">
              Change Password
            </button>
            <button
              type="button"
              className="btn btn-default-outline"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
